// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3DFRI","selected":"Chip_selected__1976O"};